module.exports = __webpack_public_path__ + "media/images/antispam_enable-3bb6349c.svg";